interface ArticleCardProps {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  image: string;
  date: string;
  views: number;
  comments: number;
  tags: string[];
  variant?: 'default' | 'large' | 'horizontal';
  className?: string;
}

function formatNumber(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  return n.toString();
}

export function ArticleCardHorizontal({
  id, title, excerpt, category, categorySlug, image, date, views, comments, tags,
}: ArticleCardProps) {
  const tagColors: Record<string, string> = {
    '明星八卦': 'bg-primary-500/20 text-primary-400',
    '视频黑料': 'bg-accent-500/20 text-accent-400',
    '图文实锤': 'bg-secondary-500/20 text-secondary-400',
    '网红翻车': 'bg-primary-500/20 text-primary-400',
    '直播吃瓜': 'bg-accent-500/20 text-accent-400',
    '娱乐深度': 'bg-secondary-500/20 text-secondary-400',
    '内娱八卦': 'bg-primary-500/20 text-primary-400',
    '经典塌房': 'bg-accent-500/20 text-accent-400',
  };

  return (
    <a href={`/article/${id}`} className="card-dark group flex flex-col sm:flex-row">
      <div className="relative w-full sm:w-[200px] lg:w-[240px] aspect-[16/10] sm:aspect-auto overflow-hidden shrink-0">
        <img src={image} alt={title} title={`${title} - 51黑料不打烊`} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-100 sm:bg-gradient-to-r sm:from-transparent sm:via-transparent sm:to-background-100"></div>
      </div>
      <div className="p-4 md:p-5 flex flex-col justify-center flex-1">
        <span className={`${tagColors[category] || 'bg-background-200 text-foreground-400'} tag-pill mb-2 w-fit`}>
          {category}
        </span>
        <h3 className="text-foreground-950 font-heading text-base md:text-lg leading-snug line-clamp-2">{title}</h3>
        <p className="text-foreground-500 text-xs md:text-sm mt-2 line-clamp-2">{excerpt}</p>
        <div className="flex items-center gap-3 mt-3 text-foreground-400 text-xs">
          <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{formatNumber(views)}</span>
          <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{formatNumber(comments)}</span>
          <span className="text-foreground-300">{date}</span>
        </div>
      </div>
    </a>
  );
}

export default function ArticleCard({
  id, title, excerpt, category, categorySlug, image, date, views, comments, tags,
}: ArticleCardProps) {
  const tagColors: Record<string, string> = {
    '明星八卦': 'bg-primary-500/20 text-primary-400',
    '视频黑料': 'bg-accent-500/20 text-accent-400',
    '图文实锤': 'bg-secondary-500/20 text-secondary-400',
    '网红翻车': 'bg-primary-500/20 text-primary-400',
    '直播吃瓜': 'bg-accent-500/20 text-accent-400',
    '娱乐深度': 'bg-secondary-500/20 text-secondary-400',
    '内娱八卦': 'bg-primary-500/20 text-primary-400',
    '经典塌房': 'bg-accent-500/20 text-accent-400',
  };

  return (
    <a href={`/article/${id}`} className="card-dark group">
      <div className="relative aspect-[4/5] overflow-hidden">
        <img src={image} alt={title} title={`${title} - 51黑料不打烊`} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
        <span className={`absolute top-3 left-3 ${tagColors[category] || 'bg-background-200 text-foreground-400'} tag-pill`}>
          {category}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="text-foreground-950 font-heading text-base leading-snug line-clamp-2">
          {title}
        </h3>
        <p className="text-foreground-500 text-xs mt-2 line-clamp-2">{excerpt}</p>
        <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200">
          <span className="text-foreground-400 text-xs">{date}</span>
          <div className="flex items-center gap-3 text-foreground-400 text-xs">
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{formatNumber(views)}</span>
            <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{formatNumber(comments)}</span>
          </div>
        </div>
      </div>
    </a>
  );
}